module.exports = __webpack_public_path__ + "img/illo_chefcry.dbcea8ff.svg";